import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";

export default function FormApprovalSetting({
  employee = {},
  convertDateTime,
}) {
  const {
    EmployeeCode,
    FirstName,
    LastName,
    DateOfBirth,
    Gender,
    DateIn,
    DateOut,
    FinishProbationDate,
    Department,
    Position,
    IsWorker,
    IsForeigner,
    IsIncomeTax,
    IsTradeUnion,
    WorkState,
    LastWorkingDate,
    TrainExpriedDate,
    IncomeTaxNo,
    TradeUnionDate,
  } = employee;
  return (
    <div>
      <div className="form-readonly">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Employee Code</div>
            <div className="form-value">
              <span>{EmployeeCode}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">First Name</div>
            <div className="form-value">
              <span>{FirstName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Last Name</div>
            <div className="form-value">
              <span>{LastName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Date Of Birth</div>
            <div className="form-value">
              <span>{convertDateTime(DateOfBirth)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Gender</div>
            <div className="form-value">
              <span>{Gender}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Date In</div>
            <div className="form-value">
              <span>{convertDateTime(DateIn)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Train Expried Date</div>
            <div className="form-value">
              <span>{convertDateTime(TrainExpriedDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Probation Finish Date</div>
            <div className="form-value">
              <span>{convertDateTime(FinishProbationDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Department</div>
            <div className="form-value">
              <span>{Department?.DepartmentName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Position</div>
            <div className="form-value">
              <span>{Position?.PositionName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Title</div>
            <div className="form-value">
              <span>{Position.Title?.TitleName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Alias</div>
            <div className="form-value">
              <span>*****</span>
            </div>
          </div>
          <CheckBox
            defaultValue={IsWorker}
            readOnly={true}
            text="Is Worker"
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsForeigner}
            readOnly={true}
            text="Is Foreigner"
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsIncomeTax}
            readOnly={true}
            text="Is Income Tax"
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsTradeUnion}
            readOnly={true}
            text="Join Trade Union"
          />
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Work State</div>
            <div className="form-value">
              <span>{WorkState}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Last Working Date</div>
            <div className="form-value">
              <span>{convertDateTime(LastWorkingDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Date Out</div>
            <div className="form-value">
              <span>{convertDateTime(DateOut)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Income Tax No</div>
            <div className="form-value">
              <span>{IncomeTaxNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Trade Union Date</div>
            <div className="form-value">
              <span>{convertDateTime(TradeUnionDate)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
